module.exports = __webpack_public_path__ + "images/jorge-pereira@2x.8197fc831cccd936d2d417de7855a3b2.jpeg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/team/jorge-pereira@2x.jpeg
// module id = 1029
// module chunks = 0